import React from 'react';
import {isEmpty} from 'lodash'
import {Grid,Chip} from "@material-ui/core"
import {useSelector} from 'react-redux'
import { injectIntl } from 'react-intl';
function DaShBoardHeader(props) {
    const authUser = useSelector(state => state.auth.authUser)
    const currentAccount = useSelector(state => state.accountsData.currentAccount)
    const saljcurrentuser = useSelector(state => state.DashBoard.saljcurrentuser)
    const DashBoardValueOf = useSelector(state => state.accountsData.DashBoardValueOf)
    const AllKontorLabel = props.intl.formatMessage({ id: 'All.In.Office' });
    const [userName,setUserName] = React.useState("")
    React.useEffect(()=>{
        const userName = isEmpty(saljcurrentuser)?"":
        (parseInt(saljcurrentuser) === -1)?
        `${currentAccount.name}`:
        parseInt(saljcurrentuser) === -2?
        AllKontorLabel:
        `${saljcurrentuser.FirstName} ${saljcurrentuser.LastName} `
        setUserName(userName)

    },[saljcurrentuser])
    return (
        <Grid container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ height: '35px',justifyContent:"space-between" }}
        >
              <Grid item className={"m-1"}></Grid>
              <Grid item >
                    {!isEmpty(DashBoardValueOf)?
                    !isEmpty(JSON.parse(DashBoardValueOf).filter(item => parseInt(item.DashBaord) === 3 && parseInt(item.Value) === 4))?
                    !isEmpty(JSON.parse(DashBoardValueOf).filter(item => parseInt(item.DashBaord) === 3 && parseInt(item.Value) === 4)[0].options)?
                    JSON.parse(DashBoardValueOf).filter(item => parseInt(item.DashBaord) === 3 && parseInt(item.Value) === 4)[0].options.map(item=>{
                        return <Chip 
                        label={item.Keyword} 
                        style={{backgroundColor: item.Color, color: 'white'}}
                        size="small"
                        className="ml-1 mb-1"
                        />
                    })
                    :""
                    :""
                    :""}
                </Grid>
                         
            </Grid>
    );
}

export default injectIntl(DaShBoardHeader);
